import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Skeleton.module.css';
function toCss(v) {
    return typeof v === 'number' ? `${v}px` : v;
}
export function Skeleton({ width = '100%', height = '1em', rounded = 'sm', className, style, }) {
    const cls = [styles.skeleton, styles[`radius-${rounded}`], className]
        .filter(Boolean)
        .join(' ');
    // Render as `<span>` (phrasing content) rather than `<div>` so a Skeleton
    // is valid anywhere text can appear — including inside `<p>` typography
    // primitives like Body / Caption. The CSS sets `display: block` so visual
    // rendering is unchanged. Without this, React 19 raises a hydration error
    // whenever a skeleton sits inside a typography primitive (e.g. group
    // header factoid placeholders).
    return (_jsx("span", { "aria-hidden": "true", className: cls, style: { width: toCss(width), height: toCss(height), ...style } }));
}
//# sourceMappingURL=Skeleton.js.map